import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

import user from './modules/user'
import system from './modules/system'
import params from './modules/params'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    system,
    params
  },
  plugins: [createPersistedState({
    paths: ['user','params'], // 只持久化 user 模块
    storage: window.localStorage, // 明确使用 localStorage
    key: 'nxzj_vuex', // 设置唯一的存储 key，避免与其他应用冲突
    // 添加错误处理，确保存储失败时不会导致应用崩溃
    getState: (key, storage) => {
      try {
        const value = storage.getItem(key)
        return value ? JSON.parse(value) : undefined
      } catch (e) {
        console.error('恢复 Vuex 状态失败:', e)
        return undefined
      }
    },
    setState: (key, state, storage) => {
      try {
        storage.setItem(key, JSON.stringify(state))
      } catch (e) {
        console.error('保存 Vuex 状态失败:', e)
        // 如果存储空间已满，尝试清理一些旧数据
        if (e.name === 'QuotaExceededError') {
          try {
            // 清理一些可能不需要的数据（保留 vuex 相关的）
            const keysToRemove = []
            for (let i = 0; i < storage.length; i++) {
              const k = storage.key(i)
              if (k && !k.startsWith('vuex') && !k.startsWith('nxzj_')) {
                keysToRemove.push(k)
              }
            }
            keysToRemove.forEach(k => storage.removeItem(k))
            // 重试存储
            storage.setItem(key, JSON.stringify(state))
          } catch (retryError) {
            console.error('重试存储仍然失败:', retryError)
          }
        }
      }
    }
  })]
})
